import { useState, useEffect } from "react";
import { getWatchListSearchResults } from "./watch-list-service";
import { WatchListSearchModel, WatchListSearchRequest } from "./types";

const useWatchListSearch = (
  searchRequest: WatchListSearchRequest | undefined,
) => {
  const [data, setData] = useState<WatchListSearchModel | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!searchRequest) return;

      setIsLoading(true);
      setError(null);

      try {
        const result = await getWatchListSearchResults(searchRequest);

        setData(result);
      } catch (err) {
        setError(err instanceof Error ? err : new Error("An error occurred"));
      } finally {
        setIsLoading(false);
      }
    };

    if (searchRequest) fetchData();
  }, [searchRequest]);

  const mutate = async () => {
    if (!searchRequest) return;

    try {
      const result = await getWatchListSearchResults(searchRequest);
      setData(result);
    } catch (err) {
      setError(err instanceof Error ? err : new Error("An error occurred"));
    }
  };

  return {
    data: data?.results,
    isLoading,
    error,
    mutate,
  };
};

export default useWatchListSearch;
